import { PropsWithChildren, useEffect, useRef, useState } from "react";
import { Colour } from "../../Variables";

export enum InfoHeaderIcon {
    House = "fa-solid fa-house",
    Positions = "fa-solid fa-briefcase",
    Email = "fa-solid fa-envelope",
    LockOpen = "fa-solid fa-lock-open",
    Padlock = "fa-solid  fa-unlock",
    PersonalDetails = "fa-solid fa-circle-user",
    Speculative = "fa-solid fa-clipboard-question",
    Register = "fa-solid fa-user",
    YourApplications = "fa-solid fa-list-check",
    CrateCandidate = "fa-solid fa-user-plus",
    None = "",
}

export type InfoHeaderProps = {
    theme: Colour,
    icon: InfoHeaderIcon,
    header: string,
    subHeader: string,
    info: string,
    narrow: boolean,
}

export function InfoBanner(props: PropsWithChildren<InfoHeaderProps>) {
    const [refHeight, setRefHeight] = useState(0);
    const refRef = useRef(null);
    
    useEffect(() => {
        const updateHeight = () => {
            if (refRef.current) {
                setRefHeight(refRef.current.offsetHeight);
            }
        };
        
        updateHeight();
        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    return (
        <>
            <div ref={refRef} className={`${props.narrow ? "container-small" : ""} ignore-central-container bg-${props.theme} shadow-sm no-highlight`}>
                <div className="container-xxl">
                    <div className="row">
                        <div className="col-lg-10 ah-bannercontent">
                            <div className="align-self-center">
                                <h2 className="">{props.header}</h2>
                                <hr className="ShortBlock" />
                                {props.subHeader != null && <h5>{props.subHeader}</h5>}
                                {props.info != null && <p className="">{props.info}</p>}
                                {props.children != null && <div className="bannerChildren">{props.children}</div>}
                            </div>
                        </div>
                        {props.icon != InfoHeaderIcon.None ?
                        <div className="col-lg-2 widescreen-only text-end align-self-center ah-bannericon">
                            <i className={`${props.icon} align-self-center ah-bannericon ${props.theme != Colour.White ? ("text-" + props.theme + "-contrast") : "backgrounded-icon"}`}></i>
                        </div> : null}
                    </div>
                </div>
            </div>
            <div style={{ minHeight: refHeight, overflow: 'hidden' }} className={`${props.narrow ? "container-small" : ""} ignore-central-spacer mb-3`} />
        </>
    );
}